
export function getDateString(date){
    if (typeof date === "string") {
      return date;
    }
    return (
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2)
    );
  }

  export function makeJustDay(date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }